import { getDecodedJwtToken } from '../utils/jwt';

const useSite = () => {
    const jwt = getDecodedJwtToken();
    const site = jwt?.site;
    return site ?? null;
};

export default useSite;
